import React, { useEffect, useState } from 'react';
import { NOTIFICATION_EDIT, NOTIFICATION_TAB_LIST } from '../../../../constants/NotificationsConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_NOTIFICATIONS,
} from '../../../../constants/RoleConsts';
import MediaViewer from '../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { daysSort } from '../../../../utils/commonUtils';
import { useSelector } from 'react-redux';
import { selectedHotelTimeZoneSelector } from '../../../property/propertySlice';
import { campainNotificatons } from '../../../services/servicesSlice';

import { decodeMediaKeyValue } from '../../../../utils/mediaUtils';

const quillHtmlToStandard = (html) => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('span.ql-ui').forEach((el) => el.remove());
  doc.querySelectorAll('ol').forEach((ol) => {
    const items = ol.querySelectorAll('li');
    const hasBullet = Array.from(items).some(
      (li) => li.getAttribute('data-list') === 'bullet',
    );
    if (hasBullet) {
      const ul = doc.createElement('ul');
      ul.style.listStyleType = 'disc';
      ul.style.paddingLeft = '1.5em';
      ul.style.margin = '0.25em 0';
      items.forEach((li) => {
        li.removeAttribute('data-list');
        li.style.margin = '0.15em 0';
        ul.appendChild(li);
      });
      ol.replaceWith(ul);
    } else {
      items.forEach((li) => li.removeAttribute('data-list'));
    }
  });
  doc.querySelectorAll('[class^="ql-"]').forEach((el) => el.removeAttribute('class'));
  return doc.body.innerHTML;
};

const NotificationView = (props) => {
  const { onViewToggle, onDrawerToggle, obj, permissions } = props;
  const selectedHotelTimeZone = useSelector(selectedHotelTimeZoneSelector);
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const allNotificationsOriginal = useSelector(campainNotificatons);
  const [currentNotificationObj, setCurrentNotificationObj] = useState(obj);

  useEffect(() => {
    if (allNotificationsOriginal.length) {
      const notificationObj = {
        ...allNotificationsOriginal.find((tempItemInfo) => tempItemInfo.id === obj.id),
      };
      setCurrentNotificationObj(notificationObj);
    }
  }, [allNotificationsOriginal, obj?.id]);

  const onOpenDrawer = (event) => {
    event.stopPropagation();
    onDrawerToggle(NOTIFICATION_EDIT, true, currentNotificationObj);
  };

  const sanitizedMessage = currentNotificationObj?.message
    ? quillHtmlToStandard(
        DOMPurify?.sanitize(currentNotificationObj?.message, {
          ADD_ATTR: ['data-list'],
        }),
      )
    : '';

  const renderScreen = () => {
    const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
      currentNotificationObj?.mediaContent,
    );

    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Title</div>
                <div className='details-value'>{currentNotificationObj?.title}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Type</div>
                <div className='details-value'>
                  {currentNotificationObj?.type ? currentNotificationObj?.type : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-fluid'>
                <div className='details-label'>Notification Message</div>
                <div className='details-value preview-breaks notif-msg'>
                  {currentNotificationObj?.message ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: sanitizedMessage }}
                      style={{ padding: 0 }}
                    />
                  ) : (
                    '---'
                  )}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Devices</div>
                <div className='details-value'>
                  {currentNotificationObj?.devices?.join(', ') ?? '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Recipient</div>
                <div className='details-value'>
                  {currentNotificationObj?.recipient === 'Both'
                    ? 'Resident & Non-resident'
                    : currentNotificationObj?.recipient}
                </div>
              </div>
            </div>
            {currentNotificationObj?.recipient === 'Resident' && (
              <div className='row mx-4'>
                <div className='col-md-6 mt-3'>
                  <div className='details-label'>Floor(s)</div>
                  <div className='details-value'>
                    {currentNotificationObj?.residentFloor?.join(', ') || '---'}
                  </div>
                </div>
                <div className='col-md-6 mt-3 '>
                  <div className='details-label'>Room Type(s)</div>
                  <div className='details-value'>
                    {currentNotificationObj?.residentRoomType?.join(', ') || '---'}
                  </div>
                </div>
                <div className='col-md-6 mt-3'>
                  <div className='details-label'>Room(s)</div>
                  <div className='details-value'>
                    {currentNotificationObj?.residentRoom?.join(', ') || '---'}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {tabValue === 1 && (
          <div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Schedule type</div>
                <div className='details-value'>
                  {currentNotificationObj?.offerSchedule?.schedule}
                </div>
              </div>
            </div>
            {currentNotificationObj?.offerSchedule?.schedule === 'One-time' && (
              <div className='row mx-4 mt-4'>
                <div className='col-fluid'>
                  <div className='details-label'>Schedule On</div>
                  <div className='details-value'>
                    {`${moment(
                      currentNotificationObj.offerSchedule?.oneTimeSchedule?.date,
                      'DD MM YYYY',
                    ).format('Do MMM YYYY')} at ${
                      currentNotificationObj?.offerSchedule?.oneTimeSchedule?.time
                    }` +
                      ' ' +
                      selectedHotelTimeZone}
                  </div>
                </div>
              </div>
            )}
            {currentNotificationObj?.offerSchedule?.schedule === 'Repeat' && (
              <div className='row mx-4 mt-4'>
                <div className='col-md-6'>
                  <div className='details-label'>Scheduled From</div>
                  <div className='details-value'>
                    {moment(
                      currentNotificationObj?.offerSchedule?.repeatSchedule?.from,
                      'DD MM YYYY',
                    ).format('Do MMM YYYY')}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='details-label'>Scheduled To</div>
                  <div className='details-value'>
                    {moment(
                      currentNotificationObj?.offerSchedule?.repeatSchedule?.to,
                      'DD MM YYYY',
                    ).format('Do MMM YYYY')}
                  </div>
                </div>
              </div>
            )}
            {currentNotificationObj?.offerSchedule?.schedule === 'Repeat' && (
              <div className='row mx-4 mt-4'>
                <div className='col-md-6'>
                  <div className='details-label'>Repeats On</div>
                  {!currentNotificationObj?.offerSchedule?.repeatSchedule?.everyday &&
                  currentNotificationObj?.offerSchedule?.repeatSchedule?.days?.length > 0 ? (
                    <div className='details-value'>
                      {daysSort(
                        currentNotificationObj?.offerSchedule?.repeatSchedule?.days?.map(
                          (day) => day.charAt(0).toUpperCase() + day.slice(1).toLowerCase(),
                        ),
                      )?.join(', ')}
                    </div>
                  ) : (
                    'EveryDay'
                  )}
                </div>
              </div>
            )}
            {currentNotificationObj?.offerSchedule?.schedule !== 'Instant' && (
              <div className='row mx-4 mt-4'>
                <div className='col-md-6'>
                  <div className='details-label'>Impressions</div>
                  <div className='details-value'>
                    {currentNotificationObj?.offerSchedule?.impressionsDay}
                  </div>
                </div>
                {currentNotificationObj?.offerSchedule?.schedule === 'Repeat' && (
                  <div className='col-md-6'>
                    <div className='details-label'>Notification Start Time</div>
                    <div className='details-value'>
                      {currentNotificationObj?.offerSchedule?.repeatSchedule?.time +
                        ' ' +
                        selectedHotelTimeZone}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {tabValue === 2 && (
          <div className='row mx-4 mt-3'>
              <MediaViewer
                images={currentNotificationObj?.images}
                videos={videoMediaContent || currentNotificationObj?.videos || {}}
                gifs={gifMediaContent || currentNotificationObj?.gifs || {}}
              />
            </div>
        )}
      </>
    );
  };

  return (
    <>
      {currentNotificationObj && (
        <DetailViewLayout
          onClickEdit={onOpenDrawer}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={NOTIFICATION_TAB_LIST}
          onViewToggle={onViewToggle}
          title={currentNotificationObj.title}
          createdUserId={currentNotificationObj.createdBy}
          isEditable={permissions[RBAC_TYPE_NOTIFICATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default NotificationView;
